module.exports = __webpack_public_path__ + "img/1.d7e89b55.jpeg";